import axios from 'axios';

// Dynamically determine the base URL based on where the app is running
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// If running locally, use the direct IP (or process.env).
// If running in production (on the domain), use '/api' so Nginx handles the secure proxying.
const BASE_URL = isLocalhost 
    ? (process.env.REACT_APP_API_URL || 'http://38.247.128.142:5000/api')
    : '/api'; 

const API = axios.create({ baseURL: BASE_URL });

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// AUTH
export const loginAPI = (data) => API.post('/auth/login', data);
export const registerAPI = (data) => API.post('/auth/register', data);

// PAYMENT
export const calculatePrice = (data) => API.post('/payment/calculate-price', data);
export const createOrder = (data) => API.post('/payment/create-order', data);
export const verifyPayment = (data) => API.post('/payment/verify-payment', data);

// OTP
export const sendOtp = (data) => API.post('/payment/send-otp', data);
export const verifyOtp = (data) => API.post('/payment/verify-otp', data);

// DASHBOARD - USER & PROFILE
export const getMyLicense = () => API.get('/v1/my-license');
export const checkStatus = () => API.get('/v1/check-status');
export const userAddEmployee = (data) => API.post('/v1/add-employee', data);
export const userRemoveEmployee = (data) => API.post('/v1/remove-employee', data);
export const userEditEmployee = (data) => API.post('/v1/edit-employee', data);
export const getProfile = () => API.get('/v1/profile');
export const updateProfile = (data) => API.put('/v1/profile', data);
export const deleteProfile = () => API.delete('/v1/profile');

// ADMIN - DATA FETCHING
export const getStats = () => API.get('/admin/stats');
export const getAllLicenses = () => API.get('/admin/all-licenses');
export const getCoupons = () => API.get('/admin/coupons');
export const getPricing = () => API.get('/admin/pricing');
export const getLocations = () => API.get('/admin/locations');
export const adminGetUsers = () => API.get('/admin/users');
export const adminGetDeletedUsers = () => API.get('/admin/users/deleted');
export const adminGetUserDetails = (email) => API.get(`/admin/users/${email}`);

// ---> NEW: Fetch Live Connections for Superadmin Dashboard
export const getLiveConnections = () => API.get('/admin/live-connections');

// ADMIN - ACTIONS
export const adminUpdateUser = (email, data) => API.put(`/admin/users/${email}`, data);
export const adminDeleteUser = (email) => API.delete(`/admin/users/${email}`);
export const generateLicense = (data) => API.post('/admin/generate-license', data);
export const createCoupon = (data) => API.post('/admin/create-coupon', data);
export const deleteCoupon = (data) => API.post('/admin/delete-coupon', data);
export const editCoupon = (data) => API.post('/admin/edit-coupon', data);
export const updateLicenseStatus = (data) => API.post('/admin/update-license-status', data);
export const toggleBanUser = (data, isBanned) => API.post(`/admin/${isBanned ? 'unban-user' : 'ban-user'}`, data);
export const addPricing = (data) => API.post('/admin/add-pricing', data);
export const editPricing = (data) => API.post('/admin/edit-pricing', data);
export const deletePricing = (data) => API.post('/admin/delete-pricing', data);
export const addLocation = (data) => API.post('/admin/add-location', data);
export const deleteLocation = (data) => API.post('/admin/delete-location', data);
export const adminAddEmployee = (data) => API.post('/admin/add-employee', data);
export const adminEditEmployee = (data) => API.post('/admin/edit-employee', data);
export const adminRemoveEmployee = (data) => API.post('/admin/remove-employee', data);